import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "27",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#262626",
  "fill-rule": "evenodd",
  d: "M10.325 7.076a.813.813 0 0 0-1.15-1.149l-6.5 6.5a.813.813 0 0 0 0 1.15l6.5 6.5a.812.812 0 1 0 1.15-1.15l-5.926-5.925zm6.5-1.149a.812.812 0 1 0-1.15 1.15l5.926 5.925-5.925 5.925a.813.813 0 0 0 1.149 1.15l6.5-6.5a.813.813 0 0 0 0-1.15z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }